angular.module('zc.core')

.directive 'zcTermsOfServiceAppierOthers', () ->
  restrict: 'E'
  templateUrl: '/templates/core/views/terms_of_service_appier_others.html'



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/views/terms_of_service_appier_others.directive.coffee